import { SelectOptionType } from '@octano/global-ui';

export interface FirstInstallmentRule {
  id: number;
  code: string;
  name: string | null;
  data: {
    date?: string;
    month?: string;
    day?: string;
    validity?: number;
  };
}

export enum AdmissionScope {
  OS = 'OS',
  OL = 'OL',
}

export interface FirstInstallmentRuleFormValues {
  firstInstallmentRule: SelectOptionType | null;
  selectDay: string | null;
  selectMonth: SelectOptionType | null;
  selectDate: string | null;
  validityRange: string | null;
  selectYear: SelectOptionType | null;
}

export interface OfferListFormValues extends FirstInstallmentRuleFormValues {
  startDate: string | null;
  duration: string | null;
  enrollmentType: SelectOptionType | null;
  maxInstallments: SelectOptionType | null;
  quota: string | null;
  offerQuota: string | null;
}

export interface Offer {
  admissionId: number;
  admissionScopes: AdmissionScope[];
  campusName: string;
  duration: string | null;
  firstInstallmentRule: FirstInstallmentRule | null;
  maxInstallments: number | null;
  scheduleName: string;
  startDate: string | null;
  studyPlanName: string;
  subprocessId: number;
  quota: number | null;
  offerQuota: number | null;
}

export interface AdmissionProcess {
  id: number;
  name: string;
  startedAt: string;
  endedAt: string;
  isEnabled: boolean;
  isMultiTuition: boolean;
  tuitionProcessTypeId: number;
  tuitionProcessTypeName: string;
  academicOfferId: number;
  periodName: string;
  firstInstallmentRule: FirstInstallmentRule | null;
  stages: any[];
  offers: Offer[];
  academicOfferQuota: number;
  totalAllocatedQuota: number;
}

export enum FirstInstallmentRuleKeys {
  SPECIFIC_DATE = 'specificDate',
  SPECIFIC_MONTH_DAY = 'specificMonthDay',
  NEXT_MONTH = 'nextMonth',
  NEXT_MONTH_DAY = 'nextMonthDay',
}

export interface ProcessUpdateBody {
  startDate: string | null;
  duration: string | null;
  admissionScopes: AdmissionScope[] | null;
  maxInstallments: number | null;
  firstInstallmentRuleValue: {
    key: string;
    value: any;
    firstInstallmentRuleId?: number;
  };
  tuitionProcessFirstInstallmentRuleId?: number;
}
